/**
 * Theme Spacing
 */

export default {
	'4xs': '0.125rem',
	'3xs': '0.25rem',
	'2xs': '0.5rem',
	xs: '0.75rem',
	s: '1rem',
	m: '1.5rem',
	l: '2rem',
	'2l': '2.25rem',
	xl: '2.5rem',
	'2xl': '3rem',
	'3xl': '3.5rem',
	layoutl: '4rem',
	layout2l: '4.25rem',
	layoutxl: '6rem',
	layout2xl: '8rem',
	layout3xl: '10.125rem',
	containerMaxWidth: '90rem',
	headerHeight: '6rem',
	footerHeight: '8.5625rem',
};
